import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'

export const PvzIcon = createSvgIcon(
  <g>
    <g clipPath="url(#clip0_8329_33993)">
      <path
        d="M13 13.5C12.4477 13.5 12 13.9477 12 14.5V21.5C12 22.0523 12.4477 22.5 13 22.5H20C20.5523 22.5 21 22.0523 21 21.5V14.5C21 13.9477 20.5523 13.5 20 13.5L13 13.5Z"
        fill="black"
        opacity="0.4"
      />
      <path
        clipRule="evenodd"
        d="M10.6351 8.76208C12.0882 8.76208 13.2661 7.58412 13.2661 6.13104C13.2661 4.67796 12.0882 3.5 10.6351 3.5C9.18199 3.5 8.00403 4.67796 8.00403 6.13104C8.00403 7.58412 9.18199 8.76208 10.6351 8.76208ZM12.0883 14.0892L12.7041 16.3504L15.9965 17.734C16.9638 18.1405 17.4424 19.2339 17.085 20.2203L11.9987 18.6535V18.6551L11.2806 18.4339C10.9239 18.3241 10.6539 18.0686 10.5138 17.754C10.4356 17.6493 10.3722 17.531 10.3276 17.4011L10.1989 17.0257L8.90441 22.5H2.97325L4.15404 20.2153L6.06435 12.1366C6.39342 10.745 7.78833 9.88358 9.17997 10.2127L10.4108 10.5037C10.912 10.6222 11.2757 11.0173 11.3784 11.4892C11.3847 11.5085 11.3907 11.5281 11.3963 11.5478C11.3976 11.5526 11.3989 11.5574 11.4002 11.5621M3.31286 27.5H2.47168C2.75067 27.5794 3.04199 27.5766 3.31286 27.5Z"
        fill="#21201F"
        fillRule="evenodd"
      />
      <path
        d="M22 22.7998L2 22.7998C2 22.2475 2.44772 21.7998 3 21.7998L21 21.7998C21.5523 21.7998 22 22.2475 22 22.7998Z"
        fill="#21201F"
      />
    </g>
    <defs>
      <clipPath id="clip0_8329_33993">
        <rect
          fill="white"
          height="24"
          transform="translate(0 0.5)"
          width="24"
        />
      </clipPath>
    </defs>
  </g>,
  'PvzIcon',
)
